import { Inject, Component, ViewChild, ElementRef } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { Sort } from '@angular/material/sort';
import { MatDrawer } from '@angular/material/sidenav'
import { compare } from '../helpers'
import { SkillsNewService } from '../skills-new.service';

export interface Interests {
  id: number;
  skill: string;
}
 
@Component({
  selector: 'skills',
  templateUrl: './manage-skills.component.html',
  styleUrls: ['./manage-skills.component.scss']
})

export class ManageSkillsComponent {

  @ViewChild('editDrawer') editDrawer!: MatDrawer;
  interestForm = new UntypedFormGroup({
    id: new UntypedFormControl({value: 0, disabled: true}),
    skill: new UntypedFormControl('')
  });
  lastSort: Sort = { active: "skill", direction: "asc" };
  editInterests: Interests = {skill: '', id: 0};
  subCategories: Interests[] = [];
  sortedData: Interests[];
  displayedColumns: string[] = ['id', 'skill', 'edit'];

  constructor(public SkillsNewService: SkillsNewService) {
    this.sortedData = this.subCategories.slice();
    // this.InterestsService = InterestsService;
    SkillsNewService.query().subscribe(response => { 
      this.subCategories = response; 
      this.sortData(this.lastSort);
    });
  }

  sortData(sort: Sort) {
    this.lastSort = sort;
    const data = this.subCategories.slice();

    if (!sort.active || sort.direction === '') {
      this.sortedData = data;
      return;
    }

    this.sortedData = data.sort((a, b) => {
      const isAsc = sort.direction   === 'asc';
      switch (sort.active) {
        case 'id':
          return compare(a.id, b.id, isAsc);
        case 'skill':
          return compare(a.skill, b.skill, isAsc);
        default:
          return 0;
      }
    });
  }

  editRow(el) {
    console.log(el);
    this.interestForm.patchValue({
      id: el.id,
      skill: el.skill
    });
    this.editDrawer.toggle();
  }

  addRow() {
    this.interestForm.patchValue({
      id: 0,
      skill: ''
    });
    this.editDrawer.toggle();
  }

  onSubmit() {
    if(this.interestForm.getRawValue().id === 0) { //new
      let subskill: any = {};
      subskill.skill = this.interestForm.getRawValue().skill;
      this.SkillsNewService.save(subskill).subscribe(res => {
        this.SkillsNewService.query().subscribe(response => { 
          this.subCategories = response; 
          this.sortedData = this.subCategories.slice(); 
        });
      });
    } else { //edit
      let subskill = this.SkillsNewService.get(this.interestForm.getRawValue().id).subscribe( subskill => {
      
        subskill.skill =  this.interestForm.getRawValue().skill;
        this.SkillsNewService.update(subskill).subscribe(response => { 
          let interests : Interests[] = [ {
            id: response.id,
            skill: response.skill
          }]
    
          const existing = this.subCategories.reduce((a,t)=> (a[t.id] = t, a), {}),
          changed = interests.reduce((a,t)=> (a[t.id] = t, a), {})
    
          this.subCategories = Object.values({...existing, ...changed})
          // this.sortedData = this.subCategories.slice(); 
          this.sortData(this.lastSort);
        });
      });
      
    }
   
  }
  
}
